import { SimpleEventDispatcher } from 'ste-simple-events';

export const complianceDocumentDefinitionEvents = {
  changed: new SimpleEventDispatcher<number>(),
};
